import axios from 'axios';
import Vue from 'vue'

var sUserAgent = navigator.userAgent.toLowerCase();
var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
var bIsMidp = sUserAgent.match(/midp/i) == "midp";
var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
var bIsAndroid = sUserAgent.match(/android/i) == "android";
var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

let ajax = axios.create({
  baseURL: '',
  headers: {
    server: '192.168.1.242'
    // server: '172.23.100.124'
    // server: '172.23.100.83'
  }
})

// axios 拦截器
ajax.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
      // 移动端
      Vue.prototype.$toast('http请求报错，请检查网络')
    } else {
      // pc 端
      Vue.prototype.$message.error('http请求报错，请检查网络')
    }

    return Promise.reject(error.response)
  });

export default ajax
